module.exports = __webpack_public_path__ + "static/media/silverrate.6ec3ee42.svg";